export enum EInsiderPageType {
  HOME = 'home',
  PRODUCT = 'product',
  CATEGORY = 'category',
  SEARCH = 'search',
  BASKET = 'cart',
  CHECKOUT_SHIPPING = 'checkout_shipping',
  CHECKOUT_PURCHASE = 'checkout_purchase',
  CONFIRMATION = 'purchase',
  CONTENT = 'content',
  OTHER = 'other',
  PROMOTIONS = 'promotions',
}

export enum EInsiderEvents {
  SEARCH_PREVIEW_ITEM_CLICK = 'search_preview_item_click',
  ADD_TO_CART = 'add_to_cart',
  REMOVE_FROM_CART = 'remove_from_cart',
}
